// extracted by mini-css-extract-plugin
module.exports = {"main-component":"loader_main-component__LZ0Ha"};